import { cva, cx } from '@vizit/theme';
import { getEntityBadgeColor, getEntityInitials } from '@vizit/utils';
import { EntityBadgeSize } from './types';

const styles = {
  badge: cva({
    base: 'flex items-center justify-center shrink-0 font-semibold text-primary-on-brand',
    variants: {
      size: {
        [EntityBadgeSize.Sm]: 'w-8 h-8 rounded-[1px] text-[8px]',
        [EntityBadgeSize.Md]: 'w-16 h-16 rounded-[2px] text-sm',
        [EntityBadgeSize.Lg]: 'w-18 h-18 text-sm',
      },
    },
  }),
};

export interface EntityBadgeProps {
  id: string;
  name: string;
  size?: EntityBadgeSize;
  className?: string;
}

function EntityBadge(props: EntityBadgeProps) {
  const { id, name, size = EntityBadgeSize.Md, className } = props;
  const initials = getEntityInitials(name);
  const backgroundColor = getEntityBadgeColor(id);

  return (
    <span aria-hidden="true" className={cx(styles.badge({ size }), className)} style={{ backgroundColor }}>
      {initials}
    </span>
  );
}

export { EntityBadge };
